import { Button } from "@komplett/design-system";
import classNames from "classnames";
import React, { useEffect, useRef } from "react";

import icons from "../../../utils/svgProvider";

interface SuccesButtonPropsI {
	bought: string;
	label: string;
	className?: string;
	onClickHandler: () => void;
	tabIndex?: number | undefined;
}

const SuccessButton = (props: SuccesButtonPropsI) => {
	const buttonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		buttonRef.current?.focus();
	}, []);

	const { bought, label, className, onClickHandler, tabIndex } = props;

	return (
		<Button
			aria-label={bought}
			className={classNames(
				"addtocart-button addtocart-buy_button added-to-cart addtocart-added",
				className,
			)}
			variant="tertiary"
			size="sm"
			ref={buttonRef}
			onClick={onClickHandler}
			tabIndex={tabIndex}
		>
			<span className="addtocart-added__content">
				{icons.checkmarkButton}
				<span
					className="checkmark__label--success"
					dangerouslySetInnerHTML={{ __html: label }}
				></span>
			</span>
		</Button>
	);
};

export default SuccessButton;
